var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36C20 27.8284 26.1074 21.0854 34 20.0997L34 51.9003C26.1074 50.9146 20 44.1716 20 36ZM38 20.0997C45.8926 21.0854 52 27.8284 52 36C52 44.1716 45.8926 50.9146 38 51.9003V20.0997Z",
    fill: "#9FE870"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 4.01296V16.0685C23.8934 17.0735 16 25.6135 16 36C16 46.3865 23.8934 54.9265 34 55.9315V67.987V72C15.048 70.9607 0 55.2403 0 36C0 16.7597 15.048 1.03934 34 0V4.01296Z",
    fill: "#9FE870"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16.0685V4.01296V0C56.952 1.03934 72 16.7597 72 36C72 55.2403 56.952 70.9607 38 72V67.987V55.9315C48.1066 54.9265 56 46.3865 56 36C56 25.6135 48.1066 17.0735 38 16.0685Z",
    fill: "#9FE870"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.f8ea583cab05023ff4c97b172e7e974a.svg";
export { ForwardRef as ReactComponent };